import styled from "styled-components";

export const CircleAlert = styled.i`
  &::before {
    font-size: 5rem;
  }
`;
